<template>
  <div class="tile-base-map-container">
    <el-scrollbar class="tile-base-map-scrollbar-container el-scrollbar-is-not-bar">
      <!-- <el-tree
        ref="treeRef"
        :data="treeData"
        show-checkbox
        node-key="id"
        :props="treeProps"
        :default-expand-all="false"
        :default-checked-keys="treeCheckIds"
        :expand-on-click-node="false"
        :check-strictly="true"
        @check="handleNodeCheck"
        class="selected-tree-table-tree"
      >
        <template #default="{ data }">
          <div class="tree-content-dom">
            <div class="map-label-group map-label-group-title"
              :title="data['name']"
            >
              <div class="map-label-group-info">
                <div class="ellipsis">{{ data['name'] }}</div>
              </div>
              <div class="map-label-group-control"
                @click.stop="mapLabelGroupAdd(data)"
              >
                <svg-icon iconName="el-Plus"></svg-icon>
              </div>
            </div>
            <div class="map-label-group"
              :class="{
                'map-label-group-checked': groupLayerMap.has(group['id']),
              }"
              v-for="(group, index) of data['markList'] || []"
              :key="index"
              :title="group['name']"
              @click.stop
            >
              <div class="map-label-group-info">
                <div class="ellipsis">{{ group['name'] }}</div>
                <div>{{ group['createTime'] }}</div>
              </div>
              <div class="map-label-group-control">
                <svg-icon iconName="el-InfoFilled" @click="mapLabelGroupLook(group)"
                  title="查看"
                ></svg-icon>
                <svg-icon iconName="el-Edit" @click="mapLabelGroupEdit(data, group)"
                  title="编辑"
                  v-if="group['type'] == 1"
                ></svg-icon>
                <svg-icon iconName="el-Share" @click="mapLabelGroupPush(data, group)"
                  title="推送"
                  v-if="checkAdminFn && group['type'] == 1"
                ></svg-icon>
                <svg-icon iconName="el-Delete" @click="mapLabelGroupDelete(group)"
                  title="删除"
                  v-if="group['type'] == 1"
                ></svg-icon>
              </div>
            </div>
          </div>
        </template>
</el-tree> -->

      <div class="tile-base-map-card" v-for="(item, index) in dataList" :key="index" :class="{
        'tile-base-map-card-checked': treeCheckIds.includes(item['id']),
      }" @click="handleNodeCheck(item)">
        <div class="tile-base-map-title ellipsis">
          <div class="tile-base-map-title-content">
            {{ item['name'] }}
          </div>
          <div class="map-label-group-add" @click.stop="workLabelEditFn(item, dataList)" title="前置标注更换底图"
            v-if="checkAdminFn">
            <svg-icon iconName="list-change"></svg-icon>
          </div>
        </div>
        <div class="tile-base-map-time">
          {{ item['start'] }} ~ {{ item['end'] }}
        </div>
        <!-- <div class="tile-base-map-mark-content">
          <div class="map-label-group"
            :class="{
              'map-label-group-checked': groupLayerMap.has(group['id']),
            }"
            v-for="(group, index) of item['markList'] || []"
            :key="index"
            :title="group['name']"
            @click.stop
          >
            <div class="map-label-group-info">
              <div class="ellipsis">{{ group['name'] }}</div>
              <div>{{ group['createTime'] }}</div>
            </div>
            <div class="map-label-group-control">
              <svg-icon iconName="el-InfoFilled" @click="mapLabelGroupLook(group)"
                title="查看"
              ></svg-icon>
              <svg-icon iconName="el-Edit" @click="mapLabelGroupEdit(item, group)"
                title="编辑"
                v-if="group['type'] == 1"
              ></svg-icon>
              <svg-icon iconName="el-Share" @click="mapLabelGroupPush(item, group)"
                title="推送"
                v-if="checkAdminFn && group['type'] == 1"
              ></svg-icon>
              <svg-icon iconName="el-Delete" @click="mapLabelGroupDelete(group)"
                title="删除"
                v-if="group['type'] == 1"
              ></svg-icon>
            </div>
          </div>
        </div> -->
      </div>
    </el-scrollbar>
    <ExportLayer v-if="exportLayerShowFlag" :target="exportLayerTarget" @close="exportLayerShowFlagChange(false)">
    </ExportLayer>
    <teleport to="#home-body" v-if="eventTarget">
      <EventInfo :target="eventTarget" @close="eventTargetClose"></EventInfo>
    </teleport>
    <!-- <EditDraw 
      :layerList="polygonLayerList"
      :parentTarget="editLayerEdit"
      ref="EditDrawRef"
      :bizType="1"
    /> -->
    <MapLabelEdit v-if="mapLabelGroupEditShowFlag" :baseTarget="mapLabelGroupEditBaseTarget"
      :target="mapLabelGroupEditTarget" @close="mapLabelGroupClose" @submitCallBack="getTreeData">
    </MapLabelEdit>
    <WorkLabelEdit v-if="workLabelEditTarget" :target="workLabelEditTarget" @close="workLabelEditTargetClose"
      :title="workLabelEditTitle"></WorkLabelEdit>
    <MapLabelPush v-if="mapLabelGroupPushTarget" :target="mapLabelGroupPushTarget"
      @close="mapLabelGroupPushTargetChange(undefined)"></MapLabelPush>
    <teleport to="#home-body" v-if="preAnnotationList && preAnnotationList.length > 0">
      <div class="tree-exposure-count-list">
        <div class="exposure-count-item exposure-count-title">
          <div>区域名称</div>
          <!-- <div>拍摄次数</div> -->
          <div>事件数</div>
        </div>
        <el-scrollbar max-height="20rem">
          <div class="exposure-count-item" v-for="(exposure, index) of preAnnotationList" :key="index"
            @click="preAnnotationListClick(exposure)">
            <div class="ellipsis">{{ (exposure['data'] || {})['annotationName'] }}</div>
            <!-- <div>{{ exposure['exposureCount'] || 0 }}</div> -->
            <div>{{ ((exposure['data'] || {})['eventList'] || []).length }}</div>
          </div>
        </el-scrollbar>
      </div>
    </teleport>
    <teleport to="#home-body">
      <!-- <RegionalShoot v-if="homeMap && !isOffline"></RegionalShoot> -->
      <ShootDataView v-if="homeMap && !isOffline"></ShootDataView>
      <StravaInit v-if="homeMap && !isOffline"></StravaInit>
    </teleport>
    <!-- <teleport to="#home-body">
      <el-radio-group v-model="isViewModeFlag" size="small"
        class="view-mode-change-radio"
      >
        <el-radio-button label="编辑模式" :value="false" />
        <el-radio-button label="查看模式" :value="true" />
      </el-radio-group>
    </teleport> -->
    <teleport to="#home-body">
      <EditPopup v-if="frequencyChart.data" class="selected-tree-table" :title="frequencyChart.title"
        :controls="frequencyChart.controls" v-move-this>
        <FrequencyChart :showFlag="true" :dataList="frequencyChart.data" ref="frequencyChartRef"></FrequencyChart>
      </EditPopup>
      <!-- <WorkBench :style="{
        right: '20rem',
      }"></WorkBench> -->
      <WorkBench :style="{
        right: '20rem',
      }"></WorkBench>
      <!-- <CreateLayer></CreateLayer> -->
    </teleport>
    <SideMap v-if="homeMap"></SideMap>
  </div>

</template>

<script setup>
import {
  ref, computed, onMounted, onUnmounted, reactive, toRaw,
  defineComponent, h, createApp, watch, nextTick,
} from "vue";
import { dayjs, message } from "@/utils/js/initVariable";
import { ElMessageBox, ElScrollbar } from 'element-plus';
import { getEventIcon } from '@/utils/js/marker-icon';
import { queryMapViewList, getPermissionPng, } from "@/api/MapManage";
import { getLeafletViewModeGroup, } from '@/utils/js/leafletViewMode';

import { dragPopupComCreate, } from '@/utils/js/leafletUtils';
import { marked } from 'marked';

import store from "@/store";
import elementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn';
import { ElRadioGroup, ElRadioButton } from 'element-plus';

import ExportLayer from "./components/ExportLayer";
import EventInfo from "./components/EventInfo";
import EditDraw from '@/views/Home/component/ManagePanel/components/CustomPolygon/components/EditDraw';
import MapLabelEdit from './components/MapLabelEdit';
import MapLabelPush from './components/MapLabelPush';

import ShootDataView from '@/views/ShootDataView';
import StravaInit from '@/views/StravaInit';
import SideMap from '@/views/Home/component/SideMap';

import EditPopup from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/EditPopup';
import FrequencyChart from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/Frequency/components/FrequencyChart';
import WorkBench from '@/views/WorkBench/index.vue';


import {
  queryFavoriteDetail, queryAdminGraphicList, delFavorite,
} from '@/api/UserDrawApi';

import { queryAnnotation, queryOtherDataByMap } from '@/api/UserWorkspaceDataApi';

import { queryRegionDirectoryTaskResult, } from '@/api/RegionDirectoryApi';

import PreAnnotationUse from './utils/PreAnnotationUse';
// 前置标注更换底图
import WorkLabelEdit from './components/WorkLabelEdit';
// 自定义区域
import CreateLayer from './components/CreateLayer';

const xlsx = require('xlsx');

const props = defineProps({});

const TIME_TYPE_MAP = {
  1: "week",
  2: "month",
  3: "quarter",
  4: "year",
};
onMounted(() => {
  getTreeData();
  // viewModeControlInit();
  queryRegionDirectoryTaskResultFn();
  map.on('zoomend', mapZoomendFn);
});
onUnmounted(() => {
  map.off('zoomend', mapZoomendFn);
  layerGroupClose();
  viewModeLayerGroupClose();
  viewModeControlClose();
})

const isOffline = ref(__IS__OFFLINE__);

const homeMap = computed(() => store.getters.getHomeMap),
  map = toRaw(homeMap.value),
  tileMap = computed(() => store.getters['homeTile/tileMap']),
  treeCheckIds = computed(() => Array.from(tileMap.value.keys()));

const layerGroup = L.featureGroup(),
  layerGroupClose = () => {
    map.removeLayer(layerGroup);
  },
  layerGroupAdd = () => {
    map.addLayer(layerGroup);
  },
  viewModeLayerGroup = L.featureGroup(),
  viewModeLayerGroupClose = () => {
    map.removeLayer(viewModeLayerGroup);
  },
  viewModeLayerGroupAdd = () => {
    map.addLayer(viewModeLayerGroup);
  }

// 持续跟踪
// 显示Flag
const regionDirectoryShowFlag = computed(() => store.getters['regionDirectoryShowFlag']);
watch(regionDirectoryShowFlag, (newd, old) => {
  if (!regionDirectoryGroup) return;
  if (newd) {
    preAnnotationMapSet(regionDirectoryKey, regionDirectoryGroup);
  } else {
    preAnnotationMapDel(regionDirectoryKey);
  }
})

let regionDirectoryGroup = undefined,
  regionDirectoryKey = '持续跟踪';
const queryRegionDirectoryTaskResultFn = () => {
  preAnnotationMapDel(regionDirectoryKey);
  queryRegionDirectoryTaskResult({}).then(res => {
    if (res.data.code == 1004) {
      // regionDirectoryInit(res.data.data);
      regionDirectoryGroup = PreAnnotationUse(
        res.data.data || [],
        frequencyChartInitFn,
        eventTargetChange,
        zoomCallBack,
        map,
      )
      if (regionDirectoryShowFlag.value) {
        preAnnotationMapSet(regionDirectoryKey, regionDirectoryGroup);
      }
    }
  }).catch(err => {
    console.log(err);
  });
}
// 持续跟踪 - end


// 进入/退出 工作模式
const isWorkMode = computed(() => store.getters['isWorkMode']);
watch(isWorkMode, (newd, old) => {
  // console.log(newd, old);
  if (newd) {
    layerGroupClose();
    viewModeLayerGroupClose();
    store.commit('homeTile/mapChange', {
      map: map,
      flag: false,
    });
  } else {
    viewModeLayerGroupAdd();
    layerGroupAdd();
    store.commit('homeTile/mapChange', {
      map: map,
      flag: true,
    });
  }
}, {
  immediate: true,
})

const checkAdminFn = computed(() => store.getters['isSuperAdmin']);

// 查看模式
let viewModeControl, viewModeControlClose = () => {
  viewModeControl && map.removeControl(viewModeControl);
}
const viewModeControlCom = () => {
  return defineComponent({
    setup() {
      return () => h(ElRadioGroup, {
        'model-value': isViewModeFlag.value,
        size: 'small',
      }, () => [
        h(ElRadioButton, {
          label: '编辑模式', value: false,
          onClick: () => {
            isViewModeFlag.value = false;
          }
        }),
        h(ElRadioButton, {
          label: '查看模式', value: true,
          onClick: () => {
            isViewModeFlag.value = true;
          }
        }),
      ])
    }
  })
}
const viewModeControlInit = () => {
  const control = L.Control.extend({
    option: {
      position: 'topright',
    },
    onAdd: function (controlMap) {
      const className = `view-mode-change`;
      const constructor = L.DomUtil.create('div', `leaflet-control leaflet-control-${className}`);
      // const content = L.DomUtil.create('div', `leaflet-control-${className}-content`, constructor),
      const contentInner = createApp(viewModeControlCom());
      contentInner.use(elementPlus, {
        locale: zhCn,
      });
      contentInner.mount(constructor);

      return constructor;
    }
  });
  viewModeControl = new control({}).addTo(map);
}

const isViewModeFlag = ref(true);
nextTick(() => {
  watch(isViewModeFlag, (newd, old) => {
    // console.log(newd, old);
    const editLayerGroupClose = EditDrawRef.value && EditDrawRef.value['layerGroupClose'],
      editLayerGroupAdd = EditDrawRef.value && EditDrawRef.value['layerGroupAdd'];
    if (newd) {
      map.removeLayer(layerGroup);
      map.addLayer(viewModeLayerGroup);
      editLayerGroupClose && editLayerGroupClose();
    } else {
      map.removeLayer(viewModeLayerGroup);
      map.addLayer(layerGroup);
      editLayerGroupAdd && editLayerGroupAdd();
    }
  }, {
    immediate: true,
  })
})

const viewModeMap = new Map(),
  viewModeMapClear = (target) => {
    const id = target['id'];
    if (!viewModeMap.has(id)) return;
    viewModeLayerGroup.removeLayer(
      viewModeMap.get(id)
    )
    viewModeMap.delete(id);
  }
const viewModeInit = (data, target) => {
  const group = getLeafletViewModeGroup(data);
  group.addTo(viewModeLayerGroup);

  const id = target['id'];
  if (viewModeMap.has(id)) {
    viewModeMapClear();
  }
  viewModeMap.set(id, group);
}

// 查看模式 - end
// 前置标注
const preAnnotationMapZoomMap = new Map(),
  zoomCallBack = (layerGroup, warningMarkerList, infoLayerGroup) => {
    const zoomHandler = (zoom) => {
      // console.log(zoom);
      if (zoom >= 6) {
        warningMarkerList.forEach(marker => {
          layerGroup.removeLayer(marker);
        })
        layerGroup.addLayer(infoLayerGroup);
        return;
      }
      if (zoom <= 4) {
        warningMarkerList.forEach(marker => {
          layerGroup.addLayer(marker);
        })
        layerGroup.removeLayer(infoLayerGroup);
      }
    };
    preAnnotationMapZoomMap.set(layerGroup, zoomHandler);
    // 移除时暂停 zoom 回调，重新添加时恢复
    layerGroup.on({
      remove: () => {
        preAnnotationMapZoomMap.delete(layerGroup);
      },
      add: () => {
        preAnnotationMapZoomMap.set(layerGroup, zoomHandler);
      }
    })
  },
  mapZoomendFn = (e) => {
    const zoom = e.target.getZoom();
    // console.log(preAnnotationMapZoomMap, zoom);
    preAnnotationMapZoomMap.forEach((val, key) => {
      // console.log(val, key);
      val && val(zoom)
    })
  }
const preAnnotationMap = ref(new Map()),
  preAnnotationMapSet = (id, group) => {
    const map = preAnnotationMap.value;
    preAnnotationMapDel(id);
    group && viewModeLayerGroup.addLayer(group);
    map.set(id, group);
    preAnnotationMap.value = new Map(map);
  },
  preAnnotationMapDel = (id) => {
    const map = preAnnotationMap.value;
    if (!map.has(id)) return;
    const group = map.get(id);
    group && viewModeLayerGroup.removeLayer(group);
    map.delete(id);
    preAnnotationMap.value = new Map(map);
  }
const preAnnotationListClick = (target) => {
  const { data, layer } = target,
    bounds = layer.getBounds();
  !isWorkMode.value && bounds.isValid() && map.fitBounds(bounds, {
    maxZoom: 7,
  });
}
const preAnnotationList = computed(() => {
  const valList = Array.from(preAnnotationMap.value.values());
  const list = valList.map(group => {
    const dataLayerList = group.options['dataLayerList'];
    return dataLayerList;
  })
  // console.log(list.flat());
  return list.flat();
})

const queryAnnotationFn = (id) => {
  queryAnnotation(`1/${id}`).then(res => {
    if (res.data.code == 1004) {
      const group = PreAnnotationUse(
        res.data.dataList || [],
        frequencyChartInitFn,
        eventTargetChange,
        zoomCallBack,
        map,
      )
      preAnnotationMapSet(id, group);
    }
  }).catch(err => {
    console.log(err);
  });
}
const frequencyChartInitFn = (item) => {
  // console.log(item);
  if ((item['exposureCountList'] || []).length == 0) return;
  frequencyChart.title = `${item['annotationName']}线索区频次`;
  frequencyChart.data = item['exposureCountList'];
}
// 前置标注 - end

// AI解读内容
let analysisResultMap = new Map(),
  analysisResultMapSet = (id, group) => {
    analysisResultMap.set(id, group);
    const map = analysisResultMap;
    analysisResultMapDel(id);
    group && viewModeLayerGroup.addLayer(group);
    map.set(id, group);
    analysisResultMap = new Map(map);
  },
  analysisResultMapDel = (id) => {
    const map = analysisResultMap;
    if (!map.has(id)) return;
    const group = map.get(id);
    group && viewModeLayerGroup.removeLayer(group);
    map.delete(id);
    analysisResultMap = new Map(map);
  }
const analysisResultGroupCreate = (data) => {
  if (!data) return;
  const resultGroup = L.featureGroup();
  // console.log(data);
  data.forEach(target => {
    let zoomClose, zoomCloseFn = () => {
      zoomClose && zoomClose();
      zoomClose = undefined;
    };
    const latlng = target['startPoint'] && L.latLng(target['startPoint'].split(',')),
      endLatlng = target['endPoint'] && L.latLng(target['endPoint'].split(',')),
      zoom = target['zoomlevel'],
      analysisResult = target['analysisResult'];
    const { app, zoomFn, group } = dragPopupComCreate(latlng, {}, {
      endLatlng, zoom, lineShow: false,
    })(
      defineComponent({
        setup() {
          const opacity = ref(0.6);
          return () => h(EditPopup, {
            controls: [
              reactive({
                iconName: 'close-box', fill: 'rgb(6, 180, 221)',
                onClick: (target, btn, control) => {
                  closeFn();
                },
              })
            ],
            style: {
              opacity: opacity.value,
            },
            onMouseover: () => {
              opacity.value = 1;
            },
            onMouseout: () => {
              opacity.value = 0.6;
            }
          },
            () => h(ElScrollbar, {
              maxHeight: 200,
              wrapStyle: {
                width: '200px',
              },
              onWheel: (e) => {
                e.stopPropagation && e.stopPropagation();
              }
            }, {
              default: () => h('div', {
                className: 'marked-change-content',
                innerHTML: marked(analysisResult),
              })
            })
          )
        }
      })
    )

    group.once({
      add: event => {
        if (zoom) {
          zoomClose = zoomFn(map);
        }
      },
      remove: event => {
        closeFn()
      }
    })

    const closeFn = () => {
      zoomCloseFn();
      app && app.unmount && app.unmount();
      group && resultGroup.removeLayer(group);
    }

    resultGroup.addLayer(group);
  })
  return resultGroup;
}
const queryOtherDataByMapFn = (id) => {
  queryOtherDataByMap(id).then(res => {
    if (res.data.code == 1004) {
      const group = analysisResultGroupCreate(res.data.data);
      analysisResultMapSet(id, group);
    }
  }).catch(err => {
    console.log(err);
  });
}
// AI解读内容 - end

// 前置标注更换底图
const workLabelEditTarget = ref(),
  workLabelEditTitle = ref(), defaultWorkLabelEditTitle = ref('前置标注更换'),
  workLabelEditTargetChange = (item) => {
    workLabelEditTarget.value = item;
    if (!item) {
      workLabelEditTitle.value = undefined;
    }
  },
  workLabelEditTargetClose = () => {
    workLabelEditTargetChange(undefined);
  }
const workLabelEditFn = (target, mapList) => {
  // console.log(target, mapList);
  const mList = mapList.map(e => {
    return {
      id: e.id,
      name: e.name,
    }
  });
  workLabelEditTargetChange({
    baseList: mList,
    id: target.id,
  })
  workLabelEditTitle.value = target['name'] + defaultWorkLabelEditTitle.value;
}
// 前置标注更换底图 - end

const exportLayerShowFlag = ref(false),
  exportLayerTarget = ref(),
  exportLayerShowFlagChange = (flag) => {
    exportLayerShowFlag.value = flag;
    if (flag) {
      exportLayerTarget.value = {
        dataList: dataList.value,
      };
    } else {
      exportLayerTarget.value = undefined;
    }
  };

const exportLayerFn = () => {
  exportLayerShowFlagChange(true);
};

const treeRef = ref();
const defaultExpandedKeys = ref([]);
const treeData = ref([]);
const treeProps = reactive({
  children: "children",
  label: "name",
  disabled: (data, node) => {
    return !data.url;
  },
});
const dataList = ref([]), changeDataList = (data) => {
  const list = [];
  const recursiveFn = (data) => {
    data.forEach(item => {
      // if(item['url']){
      //   list.push(item);
      // }
      if (!item['id']) {
        item['id'] = '0';
      } else {
        list.push(item);
      }
      if (item[treeProps['children']]) {
        recursiveFn(item[treeProps['children']]);
      }
    })
  }
  recursiveFn(data);
  return list.reverse();
}
// const polygonLayerList = computed(()=>{
//   return dataList.value.map(item=>{
//     return (item['markList'] || []).filter(mark=>{
//       return mark['type'] == 1;
//     });
//   }).flat();
// })

const tileIdToItme = (id) => {
  return (dataList.value || []).find(item => {
    return item['id'] == id;
  })
}

const polygonLayerList = ref([]), editLayerEdit = ref(),
  editLayerChangeFn = (id) => {
    // const treeCom = treeRef.value,
    //       checkList = treeCom.getCheckedKeys();
    const checkList = treeCheckIds.value;
    if (checkList.length == 0) {
      polygonLayerList.value = [];
      editLayerEdit.value = {};
      return;
    }
    const data = checkList.includes(id)
      ? tileIdToItme(id)
      : tileIdToItme(checkList.at(0));

    editLayerEdit.value = data;
    polygonLayerList.value = data['markList'];
  }

const getTreeData = async () => {
  try {
    const res = await queryMapViewList({});
    if (res.data.code == 1004) {
      // message(res.data.msg, 1);
      dataList.value = changeDataList(res.data.dataList);
      // const processedData = res.data.dataList.map(item => ({
      //   id: item.id,
      //   type: TIME_TYPE_MAP[item.timeType],
      //   year: item.year,
      //   quarter: item.quarter,
      //   month: item.month,
      //   week: item.week,
      //   startDate: dayjs(item.start),
      //   endDate: dayjs(item.end),
      //   url: item.url
      // }));
      treeData.value = res.data.dataList;
    }
    // console.log("treeData", treeData);
  } catch (err) {
    console.error("获取地图列表失败:", err);
  }
};
const frequencyChartRef = ref();
const chartDownloadFn = () => {
  frequencyChartRef.value && frequencyChartRef.value['chartDownloadFn'] && frequencyChartRef.value['chartDownloadFn']();
}

const downloadList = [
  { name: '日期', prop: 'exposureTime' },
  { name: '次数', prop: 'count' },
],
  excelHeader = downloadList.map(e => {
    return e.name;
  })
const downloadExposureFn = () => {
  const data = [
    excelHeader,
    ...(
      frequencyChart.data.map(item => {
        return downloadList.map(e => {
          return item[e.prop];
        })
      })
    )
  ];
  const ws = xlsx.utils.aoa_to_sheet(data);
  const wb = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
  xlsx.writeFile(wb, 'download.xlsx');
}
const frequencyChart = reactive({
  title: '频次',
  data: undefined,
  controls: [
    { iconName: 'download-center', fill: 'rgb(102, 203, 118)', title: '数据导出', onClick: downloadExposureFn, },
    { iconName: 'image', fill: 'rgb(102, 203, 118)', onClick: chartDownloadFn, },
    { iconName: 'close-box', fill: 'rgb(6, 180, 221)', onClick: () => { frequencyChart.data = undefined }, }
  ]
})

const mapLabelGroupEditTarget = ref(), mapLabelGroupEditBaseTarget = ref(),
  mapLabelGroupEditTitle = ref(''), mapLabelGroupEditShowFlag = ref(false),
  mapLabelGroupAdd = (baseTarget) => {
    mapLabelGroupEditTitle.value = '新增标注分组';
    mapLabelGroupEditBaseTarget.value = reactive(
      Object.assign({}, baseTarget)
    );
    mapLabelGroupEditTarget.value = reactive(
      Object.assign({ bizId: baseTarget['id'] })
    );
    mapLabelGroupEditShowFlag.value = true;
  },
  mapLabelGroupEdit = (baseTarget, target) => {
    mapLabelGroupEditTitle.value = '编辑标注分组';
    mapLabelGroupEditBaseTarget.value = reactive(
      Object.assign({}, baseTarget)
    );
    mapLabelGroupEditTarget.value = reactive(
      Object.assign({}, target, {
        bizIdList: dataList.value.map(item => item),
        bizId: baseTarget['id'],
      })
    );
    mapLabelGroupEditShowFlag.value = true;
  },
  mapLabelGroupClose = () => {
    mapLabelGroupEditTitle.value = '';
    mapLabelGroupEditBaseTarget.value = undefined;
    mapLabelGroupEditTarget.value = undefined;
    mapLabelGroupEditShowFlag.value = false;
  }

const mapLabelGroupDelete = (target) => {
  // console.log('delete', target);
  ElMessageBox.confirm(
    '是否删除当前标注分组？',
    '删除标注分组',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(res => {
    delFavorite(target['id']).then(res => {
      if (res.data.code == 1004) {
        message(res.data.msg, 1);
        getTreeData();
      }
    }).catch(err => {
      console.log(err);
    });
  }).catch(err => {
    console.log(err);
  });
}
const mapLabelGroupPushTarget = ref(),
  mapLabelGroupPushTargetChange = (target) => {
    mapLabelGroupPushTarget.value = target;
  },
  mapLabelGroupPush = (data, group) => {
    mapLabelGroupPushTargetChange(Object.assign({}, group, {
      bizId: data['id'],
    }));
  }
let groupLayerMap = ref(new Map()), groupCheckProp = ref('checked');
const exposureCountList = computed(() => {
  const valList = Array.from(groupLayerMap.value.values()),
    dataList = valList.flat().filter(layer => {
      return layer instanceof L.Marker ? false : layer['options']['dataItem'];
    }).map(layer => {
      const data = Object.assign({}, layer['options']['dataItem'], {
        layer,
      });
      return data;
    }).sort((a, b) => {
      return b['exposureCount'] - a['exposureCount'];
    })
  return dataList;
}),
  exposureCountItemClick = (item) => {
    // console.log(item);
    const layer = item['layer'],
      bounds = layer.getBounds();
    bounds.isValid() && map.fitBounds(bounds, {
      maxZoom: 7,
    });
  }

const popupComCreate = (content) => {
  return defineComponent({
    setup() {
      return () => h(ElScrollbar, {
        maxHeight: 200,
      },
        {
          default: () => h('div', {
            innerHTML: content,
          })
        })
    },
  });
}

const mapLabelGroupLook = async (group) => {
  // console.log('look', group);
  const map = groupLayerMap.value;
  const id = group['id'],
    val = map.get(id),
    checked = map.has(id);
  if (checked) {
    viewModeMapClear(group);
    mapLabelGroupClear(val, group);
    map.delete(id);
    groupLayerMap.value = new Map(map);
  } else {
    const polygonList = await mapLabelGroupInit(group);
    map.set(id, polygonList);
    groupLayerMap.value = new Map(map);
  }
},
  mapLabelGroupInit = (group) => {
    const dataChangePolygon = EditDrawRef.value && EditDrawRef.value['dataChangePolygon'];
    const dataInit = (data, resolve) => {
      // console.log(data, group);
      let polygonList = [];
      if (group['type'] == 1) {
        // 可编辑图层
        polygonList = dataChangePolygon(data.map(e => {
          return Object.assign(e, {})
        }));
      }
      // else if(group['type'] == 2){
      // 不可编辑图层
      data.forEach(item => {
        const geoJSON = JSON.parse(item['geom']);
        const geojson = L.geoJSON(geoJSON, {
          dataItem: item,
        })

        if (group['type'] == 2) {
          geojson.addTo(layerGroup);
        }

        if (item['relatedInformation']) {
          const otherList = JSON.parse(item['relatedInformation'])
          let text;
          if (otherList.length > 0) {
            text = '<p style="text-align: center;">' + item['name'] + '</p>';
            let clickText = '';
            for (let other of otherList) {
              text += `<p>${other['type']}: ${other['refer']}</p>`;
              clickText += `${clickText != '' ? '\n' : ''}${other['type']}: ${other['refer']}`;
            }
            geojson.on({
              click: click => {
                L.DomEvent.stop(click);
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                  navigator && navigator.clipboard.writeText(clickText);
                } else {
                  const save = function (e) {
                    e.clipboardData.setData('text/plain', clickText)
                    e.preventDefault() // 阻止默认行为
                  }
                  document.addEventListener('copy', save) // 添加一个copy事件
                  document.execCommand('copy') // 执行copy方法
                }
              }
            })
            // text = `<marquee behavior="scroll" direction="up" scrollamount="2" style="max-height: 200px;" >${text}</marquee>`
            // text = `<div class="scroll-box">
            //           <div class="scroll-content">
            //             ${text}
            //           </div>
            //         </div>`
            const contentCom = popupComCreate(text);
            const html = document.createElement("div");
            const app = createApp(contentCom);
            app.mount(html);

            geojson.bindPopup(html, {
              closeButton: false,
              autoClose: false,
              direction: 'top',
              className: 'leaflet-popup-message leaflet-popup-exposure-message',
            })
          } else {
            text = '<p>' + item['name'] + '</p>';
            geojson.bindTooltip(text, {
              // offset: [0, 40],
              sticky: true,
              className: "leaflet-tooltip-message leaflet-tooltip-exposure-message",
              direction: 'top',
              // maxWidth: 300,
              // maxHeight: 20,
              // permanent: true,
            })
          }
        }
        if (item['relatedPosition']) {
          const relatedPositionList = JSON.parse(item['relatedPosition']);
          const eventList = relatedPositionList.filter(e => e['webDataType'] == 'event');
          const osmList = relatedPositionList.filter(e => e['webDataType'] == 'osm');
          const dataLayerGroup = L.featureGroup().addTo(layerGroup);
          if (eventList.length > 0) {
            eventList.forEach(event => {
              const marker = L.marker(event, {
                icon: getEventIcon(event['typeName']),
              }).on({
                click: click => {
                  eventTarget.value = event;
                }
              }).bindTooltip(`<p>${event['eventName']}</p>`, {
                offset: [0, -14],
                // sticky: true,
                className: "leaflet-tooltip-message",
                direction: 'top',
                // maxWidth: 300,
                // maxHeight: 20,
                // permanent: true,
              }).addTo(dataLayerGroup);
              polygonList.push(dataLayerGroup);
            })
          }
          if (osmList.length > 0) {
            osmList.forEach(item => {
              let bindText = '';
              const properties = item['geojson']['properties'];
              // for(const key in properties){
              if (properties['name']) {
                bindText += `<p>${properties['name']}</p>`
              }
              const geojson = L.geoJSON(item['geojson'], {
                onEachFeature: (feature, layer) => {
                  // layer.setStyle({
                  //   color: osmDefaultColor,
                  // })
                },
              }).addTo(dataLayerGroup);
              if (bindText != '') {
                geojson.bindTooltip(bindText, {
                  // offset: [0, 10],
                  sticky: true,
                  className: "leaflet-tooltip-message",
                  direction: 'top',
                  // maxWidth: 300,
                  // maxHeight: 20,
                  // permanent: true,
                })
              }
              polygonList.push(dataLayerGroup);
            })
          }
        }
        if (group['type'] == 2) {
          polygonList.push(geojson);
        }
      })
      // }
      resolve(polygonList);
    }
    return new Promise((resolve) => {
      queryFavoriteDetail({
        bizType: 1,
        favoriteId: group['id'],
      }).then(res => {
        if (res.data.code == 1004) {
          dataInit(res.data.dataList, resolve);
          viewModeInit(res.data.dataList, group);
        } else {
          resolve([]);
        }
      }).catch(err => {
        resolve([]);
        console.log(err);
      });
    })
  },
  mapLabelGroupClear = (polygonList) => {
    const layerRemoveFn = EditDrawRef.value && EditDrawRef.value['layerRemoveFn'];
    if (!polygonList) return;
    polygonList.forEach(layer => {
      if (layer instanceof L.FeatureGroup) {
        layerGroup.removeLayer(layer);
      } else {
        layerRemoveFn(layer);
      }
    })
  }

//处理后端数据
const processTreeData = (data) => {
  const yearMap = new Map();
  const quarterMap = new Map();
  const monthMap = new Map();

  // 首先处理所有原始数据节点
  data.forEach((item) => {
    // 为每个原始数据节点创建key
    item.key = item.id; // 使用原始ID作为key
    item.name = generateNodeName(item);
    // 根据类型处理
    switch (item.type) {
      case "year":
        yearMap.set(`${item.year}Y`, item);
        break;
      case "quarter":
        quarterMap.set(`${item.year}Y${item.quarter}Q`, item);
        break;
      case "month":
        monthMap.set(`${item.year}Y${item.month}M`, item);
        break;
      case "week":
        // 周节点后面处理
        break;
    }
  });

  function generateNodeName(node) {
    switch (node.type) {
      case "year":
        return `${node.year}年`;
      case "quarter":
        return `${node.year}年第${node.quarter}季度`;
      case "month":
        return `${node.year}年${node.month}月`;
      case "week":
        if (node.startDate && node.endDate) {
          return `${node.year}年${node.month}月${node.startDate.format(
            "MM-DD"
          )}~${node.endDate.format("MM-DD")}`;
        }
        return `${node.year}年${node.month}月(无日期数据)`;
      default:
        return "";
    }
  }
  // 构建树形结构
  data.forEach((item) => {
    if (item.type === "week") {
      const weekNode = {
        ...item,
        key: item.id,
        name: generateNodeName(item),
        startDate: item.startDate,
        endDate: item.endDate,
      };
      // 查找周的父节点（月）
      const monthKey = `${item.year}Y${item.month}M`;
      if (monthMap.has(monthKey)) {
        if (!monthMap.get(monthKey).children) {
          monthMap.get(monthKey).children = [];
        }
        monthMap.get(monthKey).children.push(weekNode);
      } else {
        // 如果没有月节点，创建自动月节点
        const autoMonth = {
          key: monthKey, // 使用生成的key
          label: item.month,
          type: "month",
          disabled: true, // 自动创建的节点不可选
          children: [item],
        };
        monthMap.set(monthKey, autoMonth);

        // 继续向上查找季度节点
        const quarterKey = `${item.year}Y${item.quarter}Q`;
        if (quarterMap.has(quarterKey)) {
          if (!quarterMap.get(quarterKey).children) {
            quarterMap.get(quarterKey).children = [];
          }
          quarterMap.get(quarterKey).children.push(autoMonth);
        } else {
          // 如果没有季度节点，创建自动季度节点
          const autoQuarter = {
            key: quarterKey,
            label: item.quarter,
            type: "quarter",
            disabled: true,
            children: [autoMonth],
          };
          quarterMap.set(quarterKey, autoQuarter);

          // 继续向上查找年节点
          const yearKey = `${item.year}Y`;
          if (yearMap.has(yearKey)) {
            if (!yearMap.get(yearKey).children) {
              yearMap.get(yearKey).children = [];
            }
            yearMap.get(yearKey).children.push(autoQuarter);
          } else {
            // 如果没有年节点，创建自动年节点
            yearMap.set(yearKey, {
              key: yearKey,
              label: item.year,
              type: "year",
              disabled: true,
              children: [autoQuarter],
            });
          }
        }
      }
    }
  });

  // 处理非周节点（年/季/月原始数据节点）的层级关系
  Array.from(yearMap.values()).forEach((year) => {
    if (!year.children) year.children = [];

    // 处理季度节点
    Array.from(quarterMap.values())
      .filter((q) => q.year === year.label)
      .forEach((quarter) => {
        if (!year.children.some((c) => c.key === quarter.key)) {
          year.children.push(quarter);
        }

        if (!quarter.children) quarter.children = [];

        // 处理月节点
        Array.from(monthMap.values())
          .filter((m) => m.year === year.label && m.quarter === quarter.label)
          .forEach((month) => {
            if (!quarter.children.some((c) => c.key === month.key)) {
              quarter.children.push(month);
            }
          });
      });
  });
  Array.from(yearMap.values()).forEach((year) => {
    if (year.disabled) {
      year.name = `${year.label}年`;
    }
  });

  Array.from(quarterMap.values()).forEach((quarter) => {
    if (quarter.disabled) {
      quarter.name = `${quarter.year}年第${quarter.label}季度`;
    }
  });

  Array.from(monthMap.values()).forEach((month) => {
    if (month.disabled) {
      month.name = `${month.year}年${month.label}月`;
    }
  });
  // console.log(yearMap, Array.from(yearMap.values()));
  // 返回排序后的年节点
  return Array.from(yearMap.values())
    .sort((a, b) => b.label - a.label)
    .map((year) => ({
      ...year,
      children: year.children
        ?.sort((a, b) => a.label - b.label)
        .map((quarter) => ({
          ...quarter,
          children: quarter.children?.sort((a, b) => a.label - b.label),
        })),
    }));
};
// 格式化周范围显示
const formatWeekRange = (data) => {
  if (
    !data.startDate ||
    !data.endDate ||
    typeof data.startDate.format !== "function" ||
    typeof data.endDate.format !== "function"
  ) {
    console.error("Invalid date format in node:", data);
    return "日期格式错误";
  }
  return `${data.startDate.format("MM-DD")} ~ ${data.endDate.format("MM-DD")}`;
};

const eventTarget = ref(undefined), eventTargetChange = (target) => {
  eventTarget.value = target
},
  eventTargetClose = () => {
    eventTargetChange(undefined);
  }

const EditDrawRef = ref(), //绘制组件 
  polygonListProp = 'polygonList';
// 处理节点勾选事件
const currentNode = ref();
const getConfig = (url) => {
  const configStr = url.split('?').at(1),
    configList = configStr.split('&');
  const config = {};
  configList.forEach(str => {
    const keyVal = str.split('=');
    config[keyVal.at(0)] = keyVal.at(1);
  })
  return config
}

const defaultRootURL = store.getters['defaultRootURL'];
const tileDefaultZIdex = computed(() => store.getters['tileDefaultZIdex']);

const handleNodeCheck = async (node, checkedStatus) => {
  const dataChangePolygon = EditDrawRef.value && EditDrawRef.value['dataChangePolygon'];
  const layerRemoveFn = EditDrawRef.value && EditDrawRef.value['layerRemoveFn'];
  if (isWorkMode.value) return;
  // console.log(node, treeCheckIds.value.includes(node.id));
  const id = node.id, name = node.name;
  if (!treeCheckIds.value.includes(node.id)) {
    if (tileMap.value.has(id)) {
      store.commit('homeTile/mapDel', {
        id,
        map,
      })
    };
    // const url = node.url.replace('http://119.8.52.11:8123', 'https://geoserver.mizarvision.com');
    // const tile = L.tileLayerHeader(defaultRootURL + getPermissionPng() + `/{z}/{x}/{y}/${id}`, {
    //   tileSize: 256,
    //   zIndex: 10,
    //   // attribution: '<a href="https://rainviewer.com" target="_blank">rainnviewer.com</a>',
    // }, [
    //   { header: 'Authorization', value: localStorage.getItem("userToken") },
    //   { header: 'checkToken', value: localStorage.getItem("checkToken") },
    // ]);
    const tile = L.tileLayer(node.url, {
      zIndex: tileDefaultZIdex.value,
      // ...config,
    })

    tile.addTo(map);

    store.commit('homeTile/mapSet', {
      id,
      tile,
    })
    // treeRef.value.setCheckedKeys([node.id]);
    // currentNode.value = node;
    // console.log("选中节点的URL:", node);
    queryAnnotationFn(id);
    queryOtherDataByMapFn(id);
  } else {
    const tile = toRaw(tileMap.value.get(id));
    tile && map.removeLayer(tile);
    store.commit('homeTile/mapDel', {
      id,
      map,
    })
    preAnnotationMapDel(id);
    analysisResultMapDel(id);
  }
  editLayerChangeFn(id);
};

defineExpose({
  exportLayerFn,
});

</script>
<style lang="less">
.view-mode-change-radio {
  position: absolute;
  top: 60px;
  right: 55px;
}

.selected-tree-table {
  position: absolute;
  bottom: 10px;
  left: calc(var(--nav-panel-width) + 20px);
  transition: left var(--nav-collapsed-duration) ease;

  .custom-locale-control-edit-popup-body {
    width: 800px;
    height: 320px !important;
  }
}

.pre-annotation-warning {
  img {
    width: 100%;
    height: 100%;
    animation: heartBeat;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
}
</style>

<style lang="less" scoped>
.tree-exposure-count-list {
  position: absolute;
  bottom: 80px;
  right: 10px;
  border-radius: var(--borderRadiusSize_2);
  box-shadow: var(--boxShadow);
  background: var(--backgroundColor_2);
  border: 1px solid var(--borderColor_9);
  padding: 10px;
  backdrop-filter: blur(15px);
  width: 240px;

  :deep(.el-scrollbar) {
    .el-scrollbar__view {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }

  .exposure-count-item {
    display: flex;
    cursor: pointer;
    border-radius: var(--borderRadiusSize);
    padding: 5px;

    &:hover {
      background-color: var(--backgroundColor_2);
    }

    div {
      font-size: 16px;
      font-family: OPPOSans-B;

      &:nth-child(1) {
        color: var(--fontColor_5);
        text-align: left;
        flex: 1;
        min-width: 0;
      }

      &:nth-child(2),
      &:nth-child(3) {
        color: var(--fontColor_12);
        width: 60px;
        text-align: center;
      }
    }
  }

  .exposure-count-title {
    &:hover {
      background-color: transparent;
    }

    div {
      font-size: 14px;
      font-family: OPPOSans;

      &:nth-child(1) {
        color: var(--fontColor_10);
        text-align: left;
        flex: 1;
        min-width: 0;
      }

      &:nth-child(2),
      &:nth-child(3) {
        color: var(--fontColor_10);
        // width: 40px;
        text-align: center;
      }
    }
  }
}

.selected-tree-table-tree {
  :deep(.el-tree-node) {
    &:focus>.el-tree-node__content {
      background-color: transparent;
    }

    .el-tree-node__content {
      height: max-content;
      align-items: flex-start;

      &:hover {
        background-color: transparent;
      }

      .tree-content-dom {
        padding: 5px 0;
        height: max-content;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        gap: 5px;

        .base-layer-title {
          min-height: 24px;
          line-height: 24px;
        }

        .map-label-group {
          height: 24px;
          // line-height: 24px;
          background-color: var(--backgroundColor_21);
          border-radius: 5px;
          width: 140px;
          position: relative;
          overflow: hidden;
          transition: background-color 0.4s;

          .map-label-group-info {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 5px;
            height: 100%;

            div {
              &:nth-child(2) {
                width: max-content;
                color: var(--fontColor_12);
              }

              &:nth-child(1) {
                min-width: 0;
                flex: 1;
              }
            }
          }

          .map-label-group-control {
            height: 100%;
            width: 100%;
            position: absolute;
            top: -100%;
            transition: top 0.4s;
            background-color: var(--backgroundColor_23);
            border-radius: 5px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 5px;
            padding: 0 5px;

            .svg-icon {
              --iconSize: 16px;
              --hoverIconSize: 20px;
              font-size: var(--iconSize);
              width: var(--iconSize);
              height: var(--iconSize);

              &:hover {
                color: var(--iconColor_6);
                fill: var(--iconColor_6);
                font-size: var(--hoverIconSize);
                width: var(--hoverIconSize);
                height: var(--hoverIconSize);
              }
            }
          }

          &:hover {
            background-color: var(--backgroundColor_23);

            .svg-icon {
              color: var(--iconColor_3);
            }

            .map-label-group-control {
              top: 0;
            }
          }
        }

        .map-label-group-title {
          background-color: transparent;

          .map-label-group-info {
            width: max-content;
          }

          .map-label-group-control {
            justify-content: center;
          }
        }

        .map-label-group-checked {
          background-color: var(--backgroundColor_23);

          .map-label-group-info {
            div {
              color: var(--fontColor_4) !important;
            }
          }

          .svg-icon {
            color: var(--iconColor_3);
          }
        }

        .map-label-group-add {
          text-align: center;

          .svg-icon {
            font-size: 12px;
            vertical-align: 0;
          }
        }
      }
    }
  }
}

.tile-base-map-container {
  height: 100%;
  padding: 8px 5px;

  .tile-base-map-scrollbar-container {
    :deep(.el-scrollbar__view) {
      display: flex;
      flex-direction: column;
      gap: 5px;
      padding: 5px 3px;

      .tile-base-map-card {
        border-radius: var(--borderRadiusSize_4);
        box-shadow: 1px 1px 3px rgba(100, 100, 100, 0.4);
        padding: 5px;
        background-color: var(--backgroundColor_25);
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          box-shadow: 3px 3px 5px rgba(100, 100, 100, 0.4);
          // .tile-base-map-mark-content{
          //   transform: scale(1);
          // }
        }

        .tile-base-map-title {
          display: flex;
          gap: 5px;
          line-height: 24px;
          color: var(--fontColor_24);
          font-size: 16px;

          .tile-base-map-title-content {
            flex: 1;
            min-width: 0;
          }

          .map-label-group-add {
            height: 100%;
            aspect-ratio: 1 / 1;
            text-align: center;
            background-color: var(--backgroundColor_23);
            height: 24px;
            border-radius: 5px;

            .svg-icon {
              color: var(--fontColor_4);
              fill: var(--fontColor_4);
              font-size: 14px;
              vertical-align: 0;
            }
          }
        }

        .tile-base-map-time {
          line-height: 20px;
          color: var(--fontColor_26);
          font-size: 12px;
        }

        .tile-base-map-mark-content {
          display: flex;
          flex-direction: column;
          gap: 5px;
          // transform: scale(0);
          transition: all 0.3s;

          .map-label-group {
            height: 24px;
            // line-height: 24px;
            background-color: var(--backgroundColor_21);
            border-radius: 5px;
            width: 100%;
            position: relative;
            overflow: hidden;
            transition: background-color 0.4s;

            .map-label-group-info {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0 5px;
              height: 100%;

              div {
                font-size: 14px;

                &:nth-child(2) {
                  width: max-content;
                  color: var(--fontColor_12);
                }

                &:nth-child(1) {
                  min-width: 0;
                  flex: 1;
                }
              }
            }

            .map-label-group-control {
              height: 100%;
              width: 100%;
              position: absolute;
              top: -100%;
              transition: top 0.4s;
              background-color: var(--backgroundColor_23);
              border-radius: 5px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              gap: 5px;
              padding: 0 5px;

              .svg-icon {
                --iconSize: 16px;
                --hoverIconSize: 20px;
                font-size: var(--iconSize);
                width: var(--iconSize);
                height: var(--iconSize);

                &:hover {
                  color: var(--iconColor_6);
                  fill: var(--iconColor_6);
                  font-size: var(--hoverIconSize);
                  width: var(--hoverIconSize);
                  height: var(--hoverIconSize);
                }
              }
            }

            &:hover {
              background-color: var(--backgroundColor_23);

              .svg-icon {
                color: var(--iconColor_3);
              }

              .map-label-group-control {
                top: 0;
              }
            }
          }

          .map-label-group-title {
            background-color: transparent;

            .map-label-group-info {
              width: max-content;
            }

            .map-label-group-control {
              justify-content: center;
            }
          }

          .map-label-group-checked {
            background-color: var(--backgroundColor_23);

            .map-label-group-info {
              div {
                color: var(--fontColor_4) !important;
              }
            }

            .svg-icon {
              color: var(--iconColor_3);
            }
          }
        }
      }

      .tile-base-map-card-checked {
        background-color: var(--backgroundColor_34);
      }
    }
  }
}
</style>